import axios from 'axios';
import {
  compact,
  defaults,
  each,
  every,
  extend,
  filter,
  find,
  flatMap,
  go,
  identity,
  map,
  mapC,
  omit,
  pick,
  pipe,
  pluck,
  reject,
  sel,
  some,
  take,
  tap,
  uniq,
} from 'fxjs/es';
import { BpOptionConstantS } from '../../../BpOption/S/Constant/module/BpOptionConstantS.js';
import { createCanvasElement, makeCanvasByUrl, makeImageCanvasByRatio } from '../../../Canvas/S/util.js';
import { makeCanvasCut, makeTrimCanvas2 } from '../../../Maker/F/canvas_trim.js';
import { phonecase_strap_bp_ids } from '../../../Maker/F/categorize.js';
import {
  addTdeisngsToFcanvasInMaker,
  drawProductFace,
  makeProductColorByPcAndBpcId,
  makeProductColorByPcAndBpcIdAndBpId,
} from '../../../Maker/F/draw_product_faces.js';
import { getProperProductFaces } from '../../../Maker/F/getSth.js';
import { isS3Url } from '../../../Maker/F/util.js';
import { NewMakerProductStyleS } from '../../../NewMaker/ProductStyle/S/Function/module/NewMakerProductStyleS.js';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import {
  makeCylinderDesignCanvas,
  makeDesignReadyUrlAfterSetMockupUrl,
  setCompositeTemplateMockupUrl,
} from '../../Core/F/mockup_fns.js';
import { render_canvas } from '../../Core/S/composite_template_canvas.js';
import { selectAssoCompositeTemplate } from '../../Maker/F/fs.js';
import { UtilImageS } from '../../../Util/Image/S/Function/module/UtilImageS.js';

async function uploadThumbnail({ thumbnail }) {
  const url = await go(
    $.uploadFileToOnlyOriginalUrl({
      url: thumbnail.url,
      image_type: 'png',
      original_name: 'pc_thumbnail_url',
    }),
    sel('url'),
  );
  if (!url) {
    throw Error('ERROR:Image Upload');
  }
  return defaults({ url }, thumbnail);
}
export async function uploadCompositeThumbnail({ selected_base_product_colors, thumbnail }) {
  const { url, updated_at } = await go(
    axios.post(`${window.is_df ? '' : '/kr'}/@fileUpload/composite/make_composite_thumbnail`, {
      thumbnail: pick(['composite_template_id', 'design_ready_url'], thumbnail),
      selected_base_product_colors,
    }),
    sel('data'),
  );
  return defaults({ url, updated_at }, thumbnail);
}

export function makeCompositeThumbnailsWrapperWithDesignReady(assoc_composite_templates, product) {
  return go(
    assoc_composite_templates,
    map((assoc_composite_template) => {
      return {
        design_ready_url: assoc_composite_template._.composite_result.design_ready_url,
        url: null,
        is_thumb: false,
        composite_template_id: assoc_composite_template.id,
      };
    }),
    tap(function (thumbnails) {
      const original_thumb = find((thumb) => thumb.is_thumb)(sel('value', product.thumbnails));
      const new_thumb = find(
        (thumb) => thumb.composite_template_id === original_thumb?.composite_template_id,
      )(thumbnails);
      if (new_thumb) new_thumb.is_thumb = true;
      else setThumbFromOrignThumb(thumbnails, sel('value', product.thumbnails));
    }),
  );
}

export async function setAndUploadThumbnailOgImage(product_color, need_og) {
  product_color.thumbnails.value = await go(
    product_color.thumbnails.value,
    mapC((_thumbnail) => {
      if (isS3Url(_thumbnail.url)) return _thumbnail;
      if (_thumbnail.composite_template_id) {
        return uploadCompositeThumbnail({
          thumbnail: omit('_', _thumbnail),
          selected_base_product_colors: [
            {
              id: product_color.base_product_color_id,
              base_product_id: product_color.base_product_id,
            },
          ],
          pc_id: product_color.id,
        });
      } else {
        return uploadThumbnail({
          thumbnail: omit('_', _thumbnail),
          pc_id: product_color.id,
        });
      }
    }),
  );
  if (product_color.thumbnails.value[0].composite_template_id) {
    product_color.thumbnails.type = 'composite_template';
  }
  if (need_og) {
    product_color.og_image_url = await makeOgImageUrlFromPc(product_color);
  }
}

async function makeToDataUrlCompositeThumbnail(pc, thumbnail) {
  const assoc_composite_template = thumbnail._.assoc_composite_template;
  const canvas = await go(
    createCanvasElement({ width: assoc_composite_template.width, height: assoc_composite_template.height }),
    async (canvas_el) =>
      render_canvas({
        assoc_composite_template,
        canvas_el,
        design_ready_url: thumbnail.design_ready_url,
        selected_base_product_colors: go(
          [pc],
          map((pc) => {
            return {
              id: pc.base_product_color_id,
              base_product_id: pc.base_product_id,
            };
          }),
        ),
        thumbnail,
      }),
  );
  const url = canvas.toDataURL('image/png', 1.0);
  return defaults(
    {
      url,
    },
    thumbnail,
  );
}
const NFC_BADGE_BP_IDS = [8663, 8722, 8723];
export const makeOgImageUrlFromPc = async (pc) => {
  const thumbnail = find((thumbnail) => thumbnail.is_thumb, pc.thumbnails.value);
  let pf = find((pf) => pf.bpf_id === thumbnail.bpf_id, pc.product_faces2.value);
  if (!pf) pf = pc.product_faces2.value[0];
  const { width, height } = { width: 860 * 1.5, height: 860 * 1.5 };
  return go(
    undefined,
    () => {
      if (pc.thumbnails.type === 'composite_template' || NFC_BADGE_BP_IDS.includes(pc.base_product_id)) {
        return go(
          pc.thumbnails.value,
          find((thumb) => thumb.is_thumb),
          sel('url'),
          makeCanvasByUrl,
          (c) => makeImageCanvasByRatio(c, 1080, '#f6f6f6', 1 / 2, 1, 1),
        );
      } else {
        return go(makeTrimedDrawFace({ width, height }, pf, pc.base_product_id), (c) =>
          makeImageCanvasByRatio(c, 1080, '#f6f6f6', 1 / 2, 1 / 3, 4 / 5),
        );
      }
    },
    (c) =>
      $.uploadFileToOnlyOriginalUrl({
        url: c.toDataURL(),
        original_name: 'product_color_og',
        image_type: 'JPEG',
      }),
    sel('url'),
  );
};

function makeTrimedDrawFace({ width, height }, pf, base_product_id) {
  return go(
    createCanvasElement({ width, height }),
    (c) => drawProductFace(c, pf, undefined, false, true),
    (canvas) => makeTrimCanvas2(canvas),
    (c) => {
      if (phonecase_strap_bp_ids.includes(base_product_id)) {
        return makeCanvasCut(c);
      } else return c;
    },
  );
}

function makeDrawFace({ width, height }, pf) {
  return go(createCanvasElement({ width, height }), (c) => drawProductFace(c, pf, undefined, false, true));
}

function resizeCanvas(canvas, size) {
  const resize_canvas = document.createElement('canvas');
  resize_canvas.width = size;
  resize_canvas.height = size;
  const ctx = resize_canvas.getContext('2d');
  ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, size, size);
  return resize_canvas;
}

export async function makeToDataUrlThumbnail(pc, thumbnail, thumbnail_size) {
  const pf = find((pf) => pf.bpf_id === thumbnail.bpf_id, getProperProductFaces(pc));
  if (!pf) return thumbnail;
  if ([6501, 6503, 6504].includes(pc.base_product_id)) {
    if (UtilS.isNessApp()) {
      const c = await makeTrimedDrawFace({ width: 1300, height: 1300 }, pf, pc.base_product_id);
      const canvas = createCanvasElement({
        width: 1000,
        height: 1000,
      });
      const ctx = canvas.getContext('2d');
      const plus_margin = 0.1 - (c.height / 1300) * 0.1;
      const margin = 0.1 + plus_margin;
      if (c.width > c.height) {
        const width = canvas.width * (1 - margin * 2);
        const height = c.height * (width / c.width);
        ctx.drawImage(
          c,
          0,
          0,
          c.width,
          c.height,
          (canvas.width - width) / 2,
          (canvas.height - height) / 2,
          width,
          height,
        );
      } else {
        const height = canvas.height * (1 - margin * 2);
        const width = c.width * (height / c.height);
        ctx.drawImage(
          c,
          0,
          0,
          c.width,
          c.height,
          (canvas.width - width) / 2,
          (canvas.height - height) / 2,
          width,
          height,
        );
      }
      const url = thumbnail_size
        ? resizeCanvas(canvas, thumbnail_size).toDataURL()
        : canvas.toDataURL('image/png', 1);
      return defaults(
        {
          url,
        },
        thumbnail,
      );
    } else {
      const c = await makeDrawFace({ width: 1300, height: 1300 }, pf);
      const url = thumbnail_size ? resizeCanvas(c, thumbnail_size).toDataURL() : c.toDataURL('image/png', 1);
      return defaults(
        {
          url,
        },
        thumbnail,
      );
    }
  }

  const keyring_cv_obj = find((cv_obj) => cv_obj.cid == 'c2323')(pf.designs);
  const ratio = keyring_cv_obj ? 3 : 1.5;
  const { width, height } = { width: 860 * ratio, height: 860 * ratio };
  return go(
    makeTrimedDrawFace({ width, height }, pf, pc.base_product_id),
    async (c) => {
      if (keyring_cv_obj) {
        const canvas = createCanvasElement({
          width: 1000,
          height: 1000,
        });
        let v_width = 300;
        if (some((cv_obj) => cv_obj.src.includes('ee53a6642d872e227c1e83ba2f855efa677825811'))(pf.designs)) {
          v_width = 800;
        }
        if (c.width > c.height) {
          const width =
            Math.min(keyring_cv_obj._data.real_width_cm / 10, 1) * v_width + canvas.width - v_width;
          const height = c.height * (width / c.width);
          const ctx = canvas.getContext('2d');
          ctx.drawImage(
            c,
            0,
            0,
            c.width,
            c.height,
            (canvas.width - width) / 2,
            (canvas.height - height) / 2,
            width,
            height,
          );
          return canvas;
        }
        const height =
          Math.min(keyring_cv_obj._data.real_height_cm / 10, 1) * v_width + canvas.width - v_width;
        const width = c.width * (height / c.height);
        const ctx = canvas.getContext('2d');
        ctx.drawImage(
          c,
          0,
          0,
          c.width,
          c.height,
          (canvas.width - width) / 2,
          (canvas.height - height) / 2,
          width,
          height,
        );
        if (NFC_BADGE_BP_IDS.includes(pc.base_product_id)) {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.src =
            '//s3.marpple.co/files/u_193535/2025/9/original/ae189c3f595674081b27ab3751bcb5b78b9693261.png';
          /* NFC 키링 썸네일 상단 레이어 */
          await image.decode();
          // 0.75
          const nfc_canvas = document.createElement('canvas');
          /*
           * 100 / 75 -> 75% 마진 표현
           * 추가 마진 약 165로 처리
           * */
          const ADDITIONAL_MARGIN = 165;
          const size = canvas.width + ADDITIONAL_MARGIN * 2;
          nfc_canvas.width = size;
          nfc_canvas.height = size;
          const nfc_ctx = nfc_canvas.getContext('2d');
          nfc_ctx.drawImage(canvas, ADDITIONAL_MARGIN, ADDITIONAL_MARGIN);
          nfc_ctx.drawImage(
            image,
            0,
            0,
            image.width,
            image.height,
            0,
            0,
            nfc_canvas.width,
            nfc_canvas.height,
          );
          return nfc_canvas;
        }
        return canvas;
      }
      return makeImageCanvasByRatio(c, Math.max(c.width, c.height));
    },
    (c) => {
      const url = thumbnail_size ? resizeCanvas(c, thumbnail_size).toDataURL() : c.toDataURL('image/png', 1);
      return defaults(
        {
          url,
        },
        thumbnail,
      );
    },
  );
}

export async function makeToDataUrlAllThumbnails(pc) {
  return go(
    pc?.thumbnails?.value ?? [],
    reject((thumb) => thumb.is_character),
    mapC(async (thumbnail) => {
      if (thumbnail.composite_template_id) {
        if (!sel('_.assoc_composite_template', thumbnail)) {
          const assoc_composite_template = await $.get('/@api/composite/assoc_composite_template_only', {
            id: thumbnail.composite_template_id,
          });
          thumbnail._ = thumbnail._ || {};
          thumbnail._.assoc_composite_template = assoc_composite_template;
        }
        return makeToDataUrlCompositeThumbnail(pc, thumbnail);
      } else {
        return makeToDataUrlThumbnail(pc, thumbnail);
      }
    }),
  );
}

export async function makeThumbnailToProductForCustomer({ product_faces2 }) {
  const canvas = document.createElement('canvas');
  canvas.width = 400;
  canvas.height = 400;
  await drawProductFace(canvas, product_faces2.value[0], false, null, true, false);
  const obj = await $.uploadFileToOnlyOriginalUrl({ url: canvas.toDataURL('image/png') });
  return obj.url;
}

export async function makeProductColorWithThumbnailTodataurlByBpcOrBpId({ bpc_id, bp_id, product_color }) {
  bpc_id = parseInt(bpc_id);
  product_color = JSON.parse(JSON.stringify(omit(['_'], product_color)));
  const character_thumbnail = go(
    product_color.thumbnails.value,
    find((thumb) => thumb.is_character),
  );

  if (
    !product_color.product_faces2.value ||
    (product_color.thumbnails?.type === 'composite_template' &&
      !product_color.thumbnails?.value[0]?.design_ready_url)
  ) {
    const {
      data: { product_faces2, thumbnails },
    } = await axios.get(`/${T.lang}/@api/product_color/p2`, { params: { id: product_color.id } });
    product_color.product_faces2 = product_faces2;
    if (product_color.thumbnails?.type === 'composite_template') {
      product_color.thumbnails = thumbnails;
    }
  }

  if (bp_id) {
    /* 핸드폰케이스 같은 기종 변경시 데이터 변경 */
    const { new_pc } = await makeProductColorByPcAndBpcIdAndBpId(
      product_color,
      product_color.base_product_color_id,
      bp_id,
    );
    extend(product_color, omit(['_', 'thumbnails'], new_pc));
    if (sel('value', product_color.thumbnails)) {
      product_color.thumbnails.value = makeThumbnailsWrapper(product_color);
    }
  }

  if (bpc_id) {
    /* 일반 색상 변경 데이터 변경 */
    const { new_pc } = await makeProductColorByPcAndBpcId(product_color, bpc_id);
    extend(product_color, omit(['_', 'thumbnails'], new_pc));
  }

  if (sel('value', product_color.thumbnails))
    /* 합성 */
    product_color.thumbnails.value = await makeToDataUrlAllThumbnails(product_color);

  if (character_thumbnail) {
    product_color.thumbnails.value.push(character_thumbnail);
  }
  return product_color;
}

export function makeThumbnailsWrapper(pc) {
  const updated_at = new Date();
  return go(
    getProperProductFaces(pc),
    map((pf) => {
      return extend(
        {
          url: null,
          updated_at,
          is_thumb: false,
        },
        pick(['bpf_id'], pf),
      );
    }),
    tap(function (thumbnails) {
      setThumbFromOrignThumb(thumbnails, sel('value', pc.thumbnails));
    }),
  );
}
export function setThumbFromOrignThumb(thumbnails, origin_thumbnails) {
  const idx = (origin_thumbnails && origin_thumbnails.findIndex((thumbnail) => thumbnail.is_thumb)) || 0;
  if (thumbnails[idx]) thumbnails[idx].is_thumb = true;
  else thumbnails[0].is_thumb = true;
}

export async function changeThumbnailCompositeTemplate(pc, { src_ct_id, dest_ct_id }, is_with_og) {
  const assoc_composite_templates = [await selectAssoCompositeTemplate(src_ct_id)];
  pc = JSON.parse(JSON.stringify(omit(['_'], pc)));
  await setUpDesignReadyUrlInCompositeTemplate(pc, assoc_composite_templates);
  await go(
    pc.thumbnails.value,
    each(async (thumb) => {
      if (thumb.composite_template_id === dest_ct_id) {
        thumb.composite_template_id = src_ct_id;
        thumb.design_ready_url = assoc_composite_templates[0]._.composite_result.design_ready_url;
        extend(
          thumb,
          await uploadCompositeThumbnail({
            thumbnail: omit('_', thumb),
            selected_base_product_colors: [
              {
                id: pc.base_product_color_id,
                base_product_id: pc.base_product_id,
              },
            ],
            pc_id: pc.id,
          }),
        );
      }
    }),
  );
  if (is_with_og) {
    pc.og_image_url = await makeOgImageUrlFromPc(pc);
  }
  return pc;
}
async function setUpDesignReadyUrlInCompositeTemplate(pc, assoc_composite_templates) {
  await setCompositeTemplateMockupUrl(assoc_composite_templates, pc);
  await go(
    assoc_composite_templates,
    mapC(async (assoc_composite_template) => {
      assoc_composite_template._.composite_result = {
        design_ready_url: await makeDesignReadyUrlAfterSetMockupUrl(assoc_composite_template),
      };
    }),
  );
}

let i = 0;
function updateThumbnailNewThumb(assoc_composite_templates, product) {
  const bpf_ids = go(product.product_faces2.value, pluck('bpf_id'));
  const bbs = go(
    assoc_composite_templates,
    map((ct) =>
      go(
        ct._.composite_masks,
        flatMap((cm) => go(cm._.composite_faces, pluck('base_product_face_id'))),
        (base_product_face_ids) => ({
          composite_template_id: ct.id,
          bpf_ids: base_product_face_ids,
        }),
      ),
    ),
  );

  return go(
    bbs,
    filter((bb) => JSON.stringify(bb.bpf_ids) === JSON.stringify(bpf_ids)),
    (arr) => {
      return arr[i++ % arr.length];
    },
    sel('composite_template_id'),
    (ct_id) => {
      if (!ct_id) return bbs[0].composite_template_id;
      return ct_id;
    },
  );
}

export async function getThumbnailAssocCompositeTemplates(
  { product_faces2, base_product_id },
  is_for_worker,
  url,
) {
  const base_product_face_ids = product_faces2?.value?.length
    ? go(getProperProductFaces({ product_faces2 }), pluck('bpf_id'))
    : null;
  return go(
    axios.get(
      url ||
        (G.collabo_type === 'creator'
          ? UtilS.makeApiUrl('/:lang/@api/stores/:store_id/composite/assoc_composite_templates', {
              lang: T.lang,
              store_id: box.sel('store_id'),
            })
          : '/@api/composite/assoc_composite_templates'),
      {
        params: {
          base_product_id,
          composite_template_type: 'thumbnail',
          base_product_face_ids,
          is_for_worker,
        },
      },
    ),
    sel('data'),
    filter((ct) =>
      go(
        ct._.composite_masks,
        flatMap((cm) => go(cm._.composite_faces, pluck('base_product_face_id'))),
        uniq,
        (bpf_ids) => {
          if (base_product_id === 4386) return true;
          if (NewMakerProductStyleS.GALAXY_ZFLIP_BP_IDS.includes(base_product_id)) return true;
          if (ct.is_cond_or) return true;
          return every((bpf_id) => base_product_face_ids?.includes(bpf_id), bpf_ids);
        },
      ),
    ),
  );
}

async function makeProductFaceDesignCore({ print_area, width, product_face, mask_cv_obj_data }) {
  const zoom = width / print_area.width;
  const print_px = {
    top: print_area.top * zoom,
    left: print_area.left * zoom,
    width: print_area.width * zoom,
    height: print_area.height * zoom,
  };
  const f_canvas = new fabric.StaticCanvas(document.createElement('canvas'), {
    width: print_px.width,
    height: print_px.height,
    enableRetinaScaling: false,
  });
  f_canvas.getContext().imageSmoothingQuality = 'high';

  if (product_face) {
    const cv_background = product_face.cv_background;
    await go([cv_background].concat(product_face.designs).concat([mask_cv_obj_data]), compact, (designs) =>
      addTdeisngsToFcanvasInMaker(designs, f_canvas, zoom, true),
    );
    go(
      f_canvas._objects,
      each((design) => {
        design.set({
          top: Math.floor(design.top - print_px.top),
          left: Math.floor(design.left - print_px.left),
        });
      }),
    );
  }
  f_canvas.renderAll();
  return f_canvas.lowerCanvasEl;
}

async function makeProductFaceDesignFile({ product_faces2, base_product_size_id, size, target_bpf_ids }) {
  return go(
    product_faces2.value,
    filter((pf) => target_bpf_ids.includes(pf.bpf_id)),
    mapC(async (product_face) => {
      const sf = go(
        product_face.size_faces,
        find((sf) => sf.base_product_size_id == base_product_size_id),
      );
      const print_area = sf.print.px;
      const canvas = await makeProductFaceDesignCore({ print_area, width: size.width, product_face });
      const blob = await new Promise((resolve) => {
        canvas.toBlob(resolve);
      });
      const file = new File([blob], 'temp_file.' + blob.type.replace(/image\//, ''), {
        type: blob.type,
        lastModified: new Date(),
      });
      return {
        bpf_id: product_face.bpf_id,
        file,
      };
    }),
  );
}

export async function deleteTempPrintableImageFiles(composite_template) {
  const mockup_urls = go(
    composite_template,
    sel('_.composite_masks'),
    flatMap(
      pipe(
        sel('_.composite_faces'),
        map((cf) => cf.mockup_url),
      ),
    ),
  );
  await axios.delete(`/${T.lang}/@api/prerequisite_maker/temp_printable_image_files`, {
    data: { urls: mockup_urls },
  });
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function setUrlSize(composite_template, size) {
  function setUrl(url) {
    if (!url) return;
    return UtilImageS.getResizedUrl({
      width: size.width,
      url,
    });
  }
  composite_template.bg_url = setUrl(composite_template.bg_url);
  composite_template.design_texture_url = setUrl(composite_template.design_texture_url);
  composite_template.top_layer_url = setUrl(composite_template.top_layer_url);
  go(
    composite_template._.composite_masks,
    each((cm) => {
      cm.mask_transparent_url = setUrl(cm.mask_transparent_url);
      cm.map_mask_url = setUrl(cm.map_mask_url);
      cm.design_shade_url = setUrl(cm.design_shade_url);
      cm.product_url = setUrl(cm.product_url);
      cm.shade_url = setUrl(cm.shade_url);
    }),
  );
}

export async function makeMainThumbnailFromProduct({
  product: { product_faces2, base_product_size_id, base_product_color_id, base_product_id },
  composite_template,
  thumbnail_size = 900,
  maker_type,
}) {
  /* 350, 600, 900 밖에 안됌 */
  const size = {
    width: maker_type === BpOptionConstantS.MASKING_TAPE_EDITOR ? thumbnail_size * 3 : thumbnail_size,
  };
  const cylinder_width_cm = product_faces2.value[0].size_faces[0].print?.etc_meta?.cylinder_width_cm;
  const width_cm = product_faces2.value[0].size_faces[0].print?.cm?.width;
  if (cylinder_width_cm && width_cm) {
    size.width = size.width * (width_cm / cylinder_width_cm) * 3;
  }
  const target_bpf_ids = go(
    composite_template._.composite_masks,
    flatMap((cm) =>
      go(
        cm._.composite_faces,
        map((cf) => cf.base_product_face_id),
      ),
    ),
    uniq,
  );
  const design_files = await makeProductFaceDesignFile({
    product_faces2,
    base_product_size_id,
    size,
    maker_type,
    target_bpf_ids,
  });
  const design_ready_url = await go(undefined, async () => {
    if (cylinder_width_cm) {
      return go(makeCylinderDesignCanvas(composite_template), (canvas) => canvas.toDataURL());
    }
    return go(
      axios.post(
        `/${T.lang}/@api/composite/create_design_ready_url_with_file`,
        (() => {
          const formData = new FormData();
          formData.append('assoc_composite_template', JSON.stringify(composite_template));
          formData.append('size_width', thumbnail_size.toString());

          if (design_files && design_files.length > 0) {
            design_files.forEach((design_file) => {
              if (design_file && design_file.file && design_file.bpf_id) {
                formData.append('files', design_file.file);
                formData.append('bpf_ids[]', design_file.bpf_id.toString());
              }
            });
          }

          return formData;
        })(),
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          responseType: 'arraybuffer',
        },
      ),
      sel('data'),
      (buffer) => new Uint8Array(buffer),
      function (buffer) {
        const blob = new Blob([buffer], { type: 'image/png' });
        return blobToBase64(blob);
      },
    );
  });
  const canvas = document.createElement('canvas');
  setUrlSize(composite_template, size);
  await render_canvas(
    {
      assoc_composite_template: composite_template,
      canvas_el: canvas,
      selected_base_product_colors: [
        {
          id: base_product_color_id,
          base_product_id,
        },
      ],
      design_ready_url,
    },
    thumbnail_size,
  );
  // deleteTempPrintableImageFiles(composite_template).then();
  return {
    url: canvas.toDataURL(),
    design_ready_url,
  };
}

export async function setThumbnailsOgImageForPc(pc) {
  const assoc_composite_templates = await go(getThumbnailAssocCompositeTemplates(pc, false), take(5));

  return updateProductThumbnailsAndOgImage({
    pc,
    assoc_composite_templates,
    select_new_thumb: true,
    with_og: true,
  });
}
export async function makeFullNewProductWithCompositeThumbnails(
  pc,
  with_og,
  is_for_worker,
  select_new_thumb,
) {
  pc = JSON.parse(JSON.stringify(omit(['_'], pc)));
  const ct_ids = go(pc.thumbnails.value, pluck('composite_template_id'));
  const assoc_composite_templates = await go(
    getThumbnailAssocCompositeTemplates(pc, is_for_worker),
    ct_ids?.length ? filter((ct) => ct_ids.includes(ct.id)) : identity,
    take(6),
  );

  return updateProductThumbnailsAndOgImage({ pc, assoc_composite_templates, select_new_thumb, with_og });
}

export async function updateProductThumbnailsAndOgImage({
  pc,
  assoc_composite_templates,
  select_new_thumb,
  with_og,
}) {
  await setUpDesignReadyUrlInCompositeTemplate(pc, assoc_composite_templates);
  pc.thumbnails = {
    value: await go(
      makeCompositeThumbnailsWrapperWithDesignReady(assoc_composite_templates, pc),
      mapC((_thumbnail) => {
        return uploadCompositeThumbnail({
          thumbnail: omit('_', _thumbnail),
          selected_base_product_colors: [
            {
              id: pc.base_product_color_id,
              base_product_id: pc.base_product_id,
            },
          ],
          pc_id: pc.id,
        });
      }),
    ),
  };

  if (select_new_thumb) {
    const ct_id = updateThumbnailNewThumb(assoc_composite_templates, pc);
    go(
      pc.thumbnails.value,
      each((thumbnail) => (thumbnail.is_thumb = false)),
      find((thumbnail) => thumbnail.composite_template_id === ct_id),
      (thumbnail) => {
        thumbnail.is_thumb = true;
      },
    );
  }

  pc.thumbnails.type = 'composite_template';
  if (with_og) {
    pc.og_image_url = await makeOgImageUrlFromPc(pc);
  }
  return pc;
}

export async function makeFullNewProductWithNormalThumbnails(pc, with_og) {
  const { new_pc } = await makeProductColorByPcAndBpcId(pc, pc.base_product_color_id);
  new_pc.thumbnails.value = await go(
    makeThumbnailsWrapper(new_pc),
    mapC((thumbnail) => makeToDataUrlThumbnail(new_pc, thumbnail)),
    mapC((thumbnail) => uploadThumbnail({ thumbnail, pc_id: pc.id })),
  );
  if (with_og) {
    new_pc.og_image_url = await makeOgImageUrlFromPc(new_pc);
  }
  return new_pc;
}

export async function makeFullNewProductWithNormalThumbnails2(new_pc) {
  if (!new_pc.thumbnails?.value?.length) {
    return {};
  }
  return {
    thumbnails: {
      value: await go(
        makeThumbnailsWrapper(new_pc),
        mapC((thumbnail) => makeToDataUrlThumbnail(new_pc, thumbnail)),
        mapC((thumbnail) => uploadThumbnail({ thumbnail })),
      ),
    },
    og_image_url: await makeOgImageUrlFromPc(new_pc),
  };
}

export async function makeFullNewProductWithBothThumbnails(
  pc,
  is_with_og,
  is_composite,
  is_for_worker,
  is_only_og,
  change_composite,
  select_new_thumb,
) {
  if (is_only_og) {
    const new_pc = JSON.parse(JSON.stringify(omit(['_'], pc)));
    new_pc.og_image_url = await makeOgImageUrlFromPc(new_pc);
    return new_pc;
  }
  if (change_composite.src_ct_id && change_composite.dest_ct_id) {
    return changeThumbnailCompositeTemplate(pc, change_composite, is_with_og);
  }
  if (is_composite)
    return makeFullNewProductWithCompositeThumbnails(pc, is_with_og, is_for_worker, select_new_thumb);
  else return makeFullNewProductWithNormalThumbnails(pc, is_with_og);
}
